import React, { Component} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import NewUserForm from 'components/Admin/User/NewUserForm';
import actions from 'actions';
import constants from 'constants';
import validator from 'services/validator';
import inputFormatter from 'services/userInputFormatter';

const {
  ADMIN_CREATE_USER_SAGA
} = constants;

const {
  adminCreateUserSaga,
  cleanErrors
} = actions;

class NewUser extends Component {
  static propTypes = {
    createUser: PropTypes.func,
    cleanErrors: PropTypes.func,
    dispatch: PropTypes.func,
    errors: PropTypes.obj,
    errorsFrontend: PropTypes.obj
  };

  constructor(props) {
    super(props);
    this.state = {
      user: {
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        email_confirmation: '',
        validFrontend: false,
        user_type: null,
        registration: '',
        imc: ''
      }
    }
  }

  componentWillMount() {
    this.props.cleanErrors();
  }

  onFieldChange = (e) => {
    const input = inputFormatter.formatField(e.target.name, e.target.value);
    const userData = { ...this.state.user,
      ...{
        [e.target.name]: input
      }
    }

    this.setState({ user: userData });
  }

  onSubmit = () => {
    console.log('this.state.user = ', this.state.user)
    this.props.createUser(this.state.user)
  }

  render() {
    const {
      errors,
      errorsFrontend
    } = this.props;
    return (
      <main className="site--width clearfix-c">
        <NewUserForm
          onFieldChange={this.onFieldChange}
          user={this.state.user}
          onSubmit={this.onSubmit}
          errors={validator.formatErrors(errors, errorsFrontend)}
        />
      </main>
    );
  }
}

function mapStateToProps(state) {
  return {
    errors: state.errors[ADMIN_CREATE_USER_SAGA],
    errorsFrontend: state.errors[`${ADMIN_CREATE_USER_SAGA}_FRONTEND`]
  };
}

function mapDispatchToProps(dispatch) {
  return {
    createUser: (user) => dispatch(adminCreateUserSaga(user)),
    cleanErrors: () => dispatch(cleanErrors(ADMIN_CREATE_USER_SAGA)),
    dispatch: dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NewUser);



/** WEBPACK FOOTER **
 ** ./src/containers/Admin/User/NewUser.js
 **/